import { EventType } from './event-type.interface';

export const ROOM_AUDIO: EventType = {
  name: 'Room Audio Changed',
  description: 'When the audio selection playing in a room has changed',
  route: 'rooms/2',
  category: 'Room Media',
  icon: 'song',
  whitelist: [
    {
      proxy: 'roomdevice',
      events: [2]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/room-audio.type.ts